import axios from "axios";

/** Headers for HTTP requests */
const createHeaders = () => {
  return { headers: { Authorization: "Bearer " + sessionStorage.getItem("accessToken") } }
};

/** GET API request */
const getDetails = async (postUrl) => {
  try {
    const config = createHeaders();
    const { data } = await axios.get(postUrl, config);
    /** on success */
    if (data.status === 200) {
      return data;
    }
  } catch (error) {
    /** on failure */
    console.log(error);
  }
};

/** POST API request */
const postDetails = async (postUrl, payload) => {
  try {
    let config = createHeaders();
    const result = await axios.post(postUrl, payload, config)
      .catch(error => {
        if (error.response) {
          return error.response.status
        }
      });
    console.log(result);
    /** on success */
    if (result?.status === 401) {
      return 401;
    }

    return typeof result === 'number' ? result : result.data
    
  } catch (error) {
    /** on failure */
    console.log(error);
    return 500;
  }
};

/** POST API request - no headers */
const postCredentials = async (postUrl, payload) => {
  // console.log(payload);
  try {
    const result = await axios.post(postUrl, payload);
    /** on success */
    if (result.status === 200) {
      if (typeof result?.data?.error_description === "undefined")
        return { data: result.data, message: "success" };
      else return { data: null, message: result.data?.error_description };
    }
  } catch (error) {
    /** on failure */
    console.log(error);
    return { data: null, message: error?.message };
  }
};

export { getDetails, postDetails, postCredentials };
